import React from 'react';
import DropdownMenu from '../../../../common/MenuDropdown';
import Timestamp from './Timestamp';
import { chatActions, chatType, messageType } from '../../ChatController';
import UserPopup from '../../../../common/Popups/User';
import ReplyIcon from '@mui/icons-material/Reply';
import { useSelector } from 'react-redux';

function LeftMessage({ children, message, onReplyClick, messageActions, showActions, fullWidth, chips, showReplyIcon = true, isSearchMessage, messageOnclick, showJumbIcon }) {

    const senderName = message?.author?.display_name ? message?.author?.display_name : '';
    const { openedConversationId, conversationDetails } = useSelector((state) => state.conversations);
    const openedConversationDetail = conversationDetails?.[openedConversationId];

    const getFilteredMessageActions = () => {
        const possibleActions = [chatActions.copy, chatActions.reply, chatActions.forwardMessageToWhatsapp, chatActions.notify_end_user];
        return messageActions.filter((action) => {
            if (action?.key === chatActions.copy && (message.type === messageType.attachments || message.type === messageType.card)) {
                return false;
            } else if (chatActions.forwardMessageToWhatsapp === action?.key && message?.conversation?.type === chatType?.help) {
                return false
            } else if (action?.key === chatActions.notify_end_user) {
                return message.type !== messageType.attachments && openedConversationDetail?.type === chatType.ticket;
            }
            return possibleActions.includes(action.key);
        });
    };

    const dropDown = () => {
        return (
            <>
                <DropdownMenu
                    menuData={getFilteredMessageActions()}
                    dropDownClass='text-font16 text-scogoprimary invisible left_right_message'
                    componentOrIcon={'more_vert'}
                    item={message}
                    payload={{ onReplyClick }}
                />
            </>
        );
    };

    return (
        <>
            <div className={`relative flex gap-2 ${isSearchMessage ? "hover:bg-cyan-50 py-1 cursor-pointer" : ""}`} onClick={() => {
                if (isSearchMessage) {
                    messageOnclick(message?.chat_id, message?.id)
                }
            }}>
                <div className={`max-w-[66%] min-w-chat bg-mesColor px-2 rounded-t-lg rounded-r-lg relative shadow-sm pb-1`}>
                    <img
                        className='top-2 left-2 absolute h-8 w-8 rounded-full object-cover border border-gray-100'
                        src={message?.author?.avatar_link}
                        alt={senderName || 'User'}
                    />
                    <div className='relative pt-2'>
                        <div className='flex w-full pl-1 items-center'>
                            {message?.author_id ? (
                                <UserPopup userId={message?.author_id}>
                                    <p className='text-scogo15 text-font12 font-semibold ml-9 w-[85%] whitespace-nowrap text-ellipsis overflow-hidden h-6 hover:underline'>{senderName}</p>
                                </UserPopup>
                            ) : (
                                <p className='text-scogo15 text-font12 font-semibold ml-9 w-[85%] whitespace-nowrap text-ellipsis overflow-hidden h-6'>{senderName}</p>
                            )}
                            {message.is_edited && <span className='text-font8 text-scogogray italic mr-4'>(edited)</span>}
                        </div>
                        <div className='mt-2'>
                            {children({ repliedToBG: 'bg-white', audioClassName: 'audioLeftMessage w-11/12' })}
                        </div>
                        {!showJumbIcon && <div className='absolute right-0 top-0' style={{ transform: 'translateX(15%)' }}>
                            {dropDown()}
                        </div>}
                        {message.created_at &&
                            <div className='text-right mt-1'>
                                <Timestamp className='text-right cursor-pointer text-gray-500' timestamp={message.created_at} isSearchMessage={isSearchMessage} />
                            </div>
                        }
                    </div>
                </div>
                {showReplyIcon ?
                    <span className='hidden items-center justify-center messageDropdown hover:bg-scogoorange hover:scale-105 transition-all cursor-pointer bg-scogogray rounded-full mt-4 rounded-s-full h-8 w-8'>
                        <ReplyIcon className='text-white text-sm' onClick={() => onReplyClick(message)} />
                    </span>
                    :
                    <>
                        {showJumbIcon &&
                            <p className='hidden messageDropdown cursor-pointer bg-gray-300 hover:bg-gray-400 transition-colors h-2/4 w-1/10 justify-center rounded-md text-font09 text-black px-2 py-1'>
                                Jump
                            </p>
                        }
                    </>
                }
            </div>
            {chips(message.chat_id)}
        </>
    );
}

export default LeftMessage;
